import React, { useState } from "react";
import styles from "./Contact.module.css";
import {
  ArrowUp,
  ArrowUpRight,
  Check,
  Copy,
  Download,
  Mail,
  MapPin,
  Send,
} from "../common/Icons";
import { Discord, Github, Linkedin, MSTeams } from "../common/BrandIcons";
import LiquidGlass from "../common/LiquidGlass";
import Reveal from "../common/Reveal";
import SectionIntro from "../common/SectionIntro";

const EMAIL = "pratiksingh067@gmail.com";
const GITHUB_URL = "https://github.com/PratikTomar";
const LINKEDIN_URL = "https://www.linkedin.com/in/pratik-singh-tomar/";
const RESUME_URL = "/Pratik_Singh_Resume.pdf";

const channels = [
  { key: "email", label: "Email", value: EMAIL, href: `mailto:${EMAIL}`, icon: Mail },
  {
    key: "linkedin",
    label: "LinkedIn",
    value: "in/pratik-singh-tomar",
    href: LINKEDIN_URL,
    icon: Linkedin,
    external: true,
  },
  {
    key: "github",
    label: "GitHub",
    value: "@PratikTomar",
    href: GITHUB_URL,
    icon: Github,
    external: true,
  },
  {
    key: "resume",
    label: "Resume",
    value: "PDF, one page",
    href: RESUME_URL,
    download: true,
    icon: Download,
  },
  {
    key: "discord",
    label: "Discord",
    value: "@asilentassasin",
    copy: "@asilentassasin",
    icon: Discord,
  },
  {
    key: "teams",
    label: "Microsoft Teams",
    value: "pratiksingh067",
    copy: "pratiksingh067",
    icon: MSTeams,
  },
];

const Contact = () => {
  const [copiedKey, setCopiedKey] = useState("");

  const copyValue = (value, key) => {
    if (navigator.clipboard?.writeText) {
      navigator.clipboard.writeText(value);
    }
    setCopiedKey(key);
    setTimeout(() => setCopiedKey(""), 2000);
  };

  return (
    <footer id="contact" className={styles.footer}>
      <div className={styles.section}>
        <SectionIntro
          index="05"
          label="Contact"
          title="Say hello."
          lede="Email is the fastest route. I read everything and usually answer within a day."
        />

        <Reveal as={LiquidGlass} blur="soft" wash className={styles.contactCard}>
          <div className={styles.columns}>
            <Reveal className={styles.primary}>
              <a className={styles.email} href={`mailto:${EMAIL}`}>
                {EMAIL}
              </a>

              <div className={styles.actions}>
                <a className={styles.sendBtn} href={`mailto:${EMAIL}`}>
                  <Send size={15} />
                  <span>Write to me</span>
                </a>
                <button
                  type="button"
                  className={styles.copyBtn}
                  onClick={() => copyValue(EMAIL, "email")}
                >
                  {copiedKey === "email" ? (
                    <Check size={15} className={styles.copiedIcon} />
                  ) : (
                    <Copy size={15} />
                  )}
                  <span>{copiedKey === "email" ? "Copied" : "Copy address"}</span>
                </button>
              </div>

              <p className={styles.note}>
                Based in Bangalore, UTC+5:30. Open to senior full-stack and AI engineering roles,
                contract work and technical advisory.
              </p>
            </Reveal>

            <Reveal as="ul" className={styles.channels} delay={90}>
              {channels.map((channel) => {
                const IconComponent = channel.icon;
                const isCopied = copiedKey === channel.key;

                const content = (
                  <>
                    <span className={styles.channelIcon} aria-hidden="true">
                      <IconComponent size={16} />
                    </span>
                    <span className={styles.channelBody}>
                      <span className={styles.channelLabel}>{channel.label}</span>
                      <span className={styles.channelValue}>
                        {isCopied ? "Copied to clipboard" : channel.value}
                      </span>
                    </span>
                    <span className={styles.channelMark} aria-hidden="true">
                      {channel.copy ? <Copy size={13} /> : <ArrowUpRight size={13} />}
                    </span>
                  </>
                );

                return (
                  <li key={channel.key}>
                    {channel.href ? (
                      <a
                        className={styles.channel}
                        href={channel.href}
                        {...(channel.download
                          ? { download: "Pratik_Singh_Tomar_Resume.pdf" }
                          : channel.external
                            ? { target: "_blank", rel: "noreferrer" }
                            : {})}
                      >
                        {content}
                      </a>
                    ) : (
                      <button
                        type="button"
                        className={styles.channel}
                        onClick={() => copyValue(channel.copy, channel.key)}
                        title={`Copy ${channel.value}`}
                      >
                        {content}
                      </button>
                    )}
                  </li>
                );
              })}
            </Reveal>
          </div>
        </Reveal>
      </div>

      <div className={styles.bottom}>
        <span className={styles.place}>
          <MapPin size={13} />
          Bangalore, IN · UTC+5:30
        </span>
        <p className={styles.colophon}>
          © {new Date().getFullYear()} Pratik Singh Tomar · Set in Newsreader and Urbanist
        </p>
        <a className={styles.topBtn} href="#top" aria-label="Back to top of page">
          <ArrowUp size={13} />
          <span>Top</span>
        </a>
      </div>
    </footer>
  );
};

export default Contact;
